export const MILESTONE_STATUSES = {
  CANCELLED_DECLINED: 'Cancelled/Declined',
  IN_PROGRESS: 'In Progress',
  NOT_STARTED: 'Not Started',
  ACTION_REQUIRED: 'Action required',
  COMPLETED: 'Completed'
};

export const DECLINED = 'Decline';

export const TITLES = [
  'Mr',
  'Mrs',
  'Ms',
  'Miss',
  'Dr',
  'Earl',
  'Reverend',
  'Professor',
  'Major',
  'Sister',
  'Sir',
  'Viscount',
  'Countess',
  'Hon',
  'Lord',
  'Lady',
  'Captain',
  'Colonel',
  'Master',
  'Other'
];
